import React, { useState } from 'react';
import { MDBCard, MDBCardBody, MDBBtn } from 'mdb-react-ui-kit';

const ProductActivity = () => {
  const [activeFilter, setActiveFilter] = useState('weekly');
  const [isAnimating, setIsAnimating] = useState(false);

  const data = {
    daily: [12, 19, 8, 15, 22, 18, 23],
    weekly: [85, 92, 78, 105, 118, 95, 142, 156, 134, 128, 145, 162],
    monthly: [450, 520, 480, 610, 680, 590, 720, 780, 690, 640, 710, 820]
  };

  const labels = {
    daily: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
    weekly: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10', 'W11', 'W12'],
    monthly: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  };

  const handleFilterChange = (filter) => {
    setIsAnimating(true);
    setTimeout(() => {
      setActiveFilter(filter);
      setIsAnimating(false);
    }, 300);
  };

  const maxValue = Math.max(...data[activeFilter]);
  const currentData = data[activeFilter];
  const currentLabels = labels[activeFilter];

  return (
    <MDBCard className="dashboard-card activity-card">
      <MDBCardBody>
        <div className="card-header">
          <h3 className="card-title">Product Upload Activity</h3>
          <div className="filter-buttons">
            {['daily', 'weekly', 'monthly'].map(filter => (
              <MDBBtn
                key={filter}
                size="sm"
                className={`filter-btn ${activeFilter === filter ? 'active' : ''}`}
                onClick={() => handleFilterChange(filter)}
              >
                {filter.charAt(0).toUpperCase() + filter.slice(1)}
              </MDBBtn>
            ))}
          </div>
        </div>
        
        <div className={`chart-container activity-chart ${isAnimating ? 'animating' : ''}`}>
          <div className="chart-area">
            {currentData.map((value, index) => (
              <div key={`${activeFilter}-${index}`} className="bar-container">
                <div 
                  className="activity-bar"
                  style={{ 
                    height: `${(value / maxValue) * 100}%`,
                    animationDelay: `${index * 0.1}s`
                  }}
                  data-value={value}
                >
                  <div className="bar-tooltip">{value}</div>
                </div>
                <div className="bar-label">{currentLabels[index]}</div>
              </div>
            ))}
          </div>
        </div>
      </MDBCardBody>
    </MDBCard>
  );
};

export default ProductActivity;